export default __webpack_public_path__ + "static/media/position.2d482527.svg";